import { Col, Row } from "antd";
import cuid from "cuid";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { get } from "lodash";
import moment from "moment";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { DATE_FORMAT } from "utils/constants";
import {
  bindDateInputProps,
  bindInputProps,
  bindWebTextFieldInputProps,
} from "utils/helpers/input";
import { filterContractNumber } from "utils/helpers/validations";
import ActionButtons from "../Components/ActionButtons";
import Card from "../Components/Card";
import Header from "../Components/Header";
import InfoBox from "../Components/InfoBox";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import validation from "./validation";
import UpdateModal from "./Widgets/UpdateModal";

function View({
  contract,
  ria,
  onSubmit,
  onBack,
  deltas,
  locked,
  fields,
  terminationRequest,
  initialValues,
  recalculateCost,
  generalCost,
  subscription,
  isCollective,
}) {
  const { t } = useTranslation();

  const [showChangeCostModal, setShowChangeCostModal] = useState({});
  const [deltaStart, setDeltaStart] = useState(1);
  const [validStartDate, setValidStartDate] = useState();
  const [validEndDate, setValidEndDate] = useState();
  const [oldIssuanceDate, setOldIssuanceDate] = useState(
    get(initialValues, "project.contract.issuanceDate"),
  );
  const [hasContractInfo, setHasContractInfo] = useState(false);

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      contract,
      ria,
      locked,
      fields,
      terminationRequest,
    },
    onSubmit: onSubmit,
    validateOnMount: true,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
      {
        deltaRia: get(deltas, "start.ria"),
        deltaStart: get(deltas, "start.normal"),
        deltaEndRia: get(deltas, "end.ria"),
        deltaEnd: get(deltas, "end.normal"),
      },
    ),
  });

  const isValid = useMemo(() => {
    const projectRia = values?.ria;
    const selfOccupation = values?.fields?.selfOccupation;
    const contractNumber = values?.terminationRequest?.contractNumber;
    const currentCompany =
      values?.terminationRequest?.brokerageMandate?.currentCompany;

    if (!projectRia || selfOccupation === true) {
      return true;
    }

    if (projectRia && selfOccupation === false && hasContractInfo) {
      return Boolean(contractNumber?.trim()) && Boolean(currentCompany?.trim());
    }

    return true;
  }, [values, hasContractInfo]);

  // useEffect(() => {
  //   formProps.validateForm();
  // }, [
  //   values?.ria,
  //   values?.fields?.selfOccupation,
  //   values?.terminationRequest?.contractNumber,
  //   values?.terminationRequest?.brokerageMandate?.currentCompany,
  // ]);

  // useEffect(() => {
  //   formProps.validateForm();
  // }, [values?.contract?.issuanceDate]);

  const [pickerValue, setPickerValue] = useState(
    !get(values, "project.contract.issuanceDate") && dayjs(),
  );

  const onChangeCost = () => {
    setShowChangeCostModal({});
  };

  const onCancelChangeCost = () => {
    if (showChangeCostModal?.isRia) {
      setFieldValue("resiliation", false);
      setFieldValue("project.ria", false);
      setFieldValue("project.fields.selfOccupation", undefined);
      setFieldValue(
        "project.contract.issuanceDate",
        get(initialValues, "project.contract.issuanceDate"),
      );
      setValidStartDate(dayjs().add(deltaStart, "days"));
      setPickerValue(dayjs().add(deltaStart, "days"));
    }
    recalculateCost({
      oldIssuanceDate: values?.project?.contract?.issuanceDate,
      cost: get(generalCost, "cost"),
      issuanceDate: oldIssuanceDate,
      setFieldValue,
      setShowChangeCostModal,
      isCancel: true,
    });
  };

  return (
    <Layout>
      <UpdateModal
        showChangeCostModal={showChangeCostModal}
        insurancePlanName={get(subscription, "insurancePlan.name")}
        setShowChangeCostModal={setShowChangeCostModal}
        onChangeCost={onChangeCost}
        onCancelChangeCost={onCancelChangeCost}
      />
      <Header
        title="À partir de quelle date souhaitez-vous être couvert ?"
        highlight="souhaitez-vous être,couvert ?"
        subtitle="Informations de l’adhérent"
      />
      <Row justify="center">
        <Col xs={24} md={16} lg={12}>
          <div className="grid--1">
            {/* <Input
              type="date"
              format={DATE_FORMAT}
              placeholder={"JJ / MM / AAAA"}
              label={"Date d’effet"}
              disabledDate={(current) => current < moment()}
              // {...bindDateInputProps({
              //   name: "contract.issuanceDate",
              //   setFieldValue,
              //   values,
              //   ...formProps,
              // })}
              touched
              {...bindDateInputProps({
                name: "contract.issuanceDate",
                values,
                ...formProps,
                setFieldValue,
              })}
              onFocus={() =>
                setOldIssuanceDate(values?.project?.contract?.issuanceDate)
              }
              onChange={(date) => {
                setFieldValue("project.contract.issuanceDate", date);
                // if (
                //   date.isValid() &&
                //   date >= validStartDate &&
                //   date <= validEndDate
                // ) {
                recalculateCost({
                  oldIssuanceDate: oldIssuanceDate,
                  cost: get(generalCost, "cost"),
                  issuanceDate: date,
                  setFieldValue,
                  setShowChangeCostModal,
                });
                // }
              }}
              onBlur={({ target: { value: issuanceDate } }) => {
                const date = dayjs(issuanceDate, DATE_FORMAT).add(2, "h");
                if (
                  date.isValid() &&
                  date >= validStartDate &&
                  date <= validEndDate
                ) {
                  setFieldValue("project.contract.issuanceDate", date);
                } else
                  formProps.setFieldTouched("project.contract.issuanceDate");
              }}
              disabled={subscription?.locked}
            /> */}

            <Input
              type="date"
              format={DATE_FORMAT}
              placeholder={"JJ / MM / AAAA"}
              label={"Date d’effet"}
              disabledDate={(current) => current < moment()}
              {...bindDateInputProps({
                name: "contract.issuanceDate",
                setFieldValue,
                values,
                ...formProps,
              })}
              touched
            />
            {!isCollective && (
              <Input
                type="checkbox"
                label={
                  "Cochez cette case si vous souhaitez résilier un contrat existant souscrit depuis plus d’un an."
                }
                checked={get(values, "ria") || false}
                // onChange={({ target: { checked } }) =>
                //   setFieldValue("ria", checked)
                // }
                onChange={({ target: { checked } }) => {
                  setFieldValue("ria", checked);
                  if (checked) {
                    setFieldValue("fields.selfOccupation", true);
                    setFieldValue("terminationRequest", null);
                  } else {
                    setFieldValue("fields.selfOccupation", undefined);
                    setFieldValue("terminationRequest", null);
                  }
                }}
              />
            )}
            {values?.ria && (
              <Card>
                <div className="grid--1">
                  <Input
                    type="radio"
                    label="Comment souhaitez-vous gérer la résiliation de votre ancien contrat ?"
                    values={[
                      {
                        value: true,
                        label: "Je me charge de résilier moi-même.",
                      },
                      {
                        value: false,
                        label:
                          "Je souhaite que Mobilité Mutuelle s'en occupe pour moi.",
                      },
                    ]}
                    value={get(values, "fields.selfOccupation")}
                    defaultValue={get(values, "fields.selfOccupation")}
                    onChange={(value) => {
                      setFieldValue("fields.selfOccupation", value);
                      if (!value) {
                        setFieldValue(
                          "contract.issuanceDate",
                          moment(get(values, "contract.issuanceDate"))
                            .add(deltas.start.ria, "days")
                            .toISOString(),
                        );
                      }
                      setFieldValue(
                        "terminationRequest",
                        value
                          ? null
                          : {
                              id: cuid(),
                              brokerageMandate: { id: cuid() },
                            },
                      );
                    }}
                    variant="radioBtn"
                  />
                  {get(values, "fields.selfOccupation") === false && (
                    <div className="pt-16">
                      <InfoBox
                        variant={"default"}
                        onClick={() => setHasContractInfo((prev) => !prev)}
                        text={`Un conseiller vous contactera pour obtenir les informations de votre ancien contrat (N° de référence et nom de l’assureur ou de la mutuelle).`}
                        link={
                          hasContractInfo
                            ? "Je n’ai pas les informations nécessaires sous ma main"
                            : "J’ai les informations nécessaires sous ma main"
                        }
                      />
                      {hasContractInfo && (
                        <div className="grid--1">
                          <div className="pt-16" />
                          <Input
                            label="N° de référence de votre contrat"
                            placeholder="ex : 123456789"
                            trim
                            {...bindInputProps({
                              name: "terminationRequest.contractNumber",
                              values,
                              ...formProps,
                            })}
                            onChange={({ target: { value } }) => {
                              setFieldValue(
                                "terminationRequest.contractNumber",
                                filterContractNumber(value),
                              );
                            }}
                          />
                          <Input
                            label="Nom de mon assureur ou de ma mutuelle"
                            placeholder="ex : ABC Mutuelle"
                            {...bindWebTextFieldInputProps({
                              name: "terminationRequest.brokerageMandate.currentCompany",
                              values,
                              setFieldValue,
                              ...formProps,
                            })}
                          />
                          <InfoBox
                            variant={"info"}
                            text={
                              "Votre contrat prendra effet au minimum dans 34 jours, le temps pour nous de gérer votre résiliation auprès de votre ancienne mutuelle."
                            }
                          />
                          <InfoBox
                            variant={"default"}
                            title="Vous ne les avez pas sous la main ?"
                            text={
                              "Pas de panique, nous prendrons contact avec vous après votre souscription."
                            }
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Card>
            )}
          </div>
        </Col>
      </Row>

      <ActionButtons
        disabled={!isValid}
        onNext={handleSubmit}
        onBack={onBack}
      />
    </Layout>
  );
}

export default View;
